module.exports = __webpack_public_path__ + "static/media/starfighter.bb571a71.svg";